export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7295.df94ff95.jpg";